import React from 'react'

import * as S from './styled'

type DropdownHeadingProps = {
  label: string
}

export const DropdownHeading = ({ label }: DropdownHeadingProps) => (
  <S.Container>{label}</S.Container>
)
